import { createAction, props } from '@ngrx/store';
import { CartItemsDataV2, CartSummaryV2 } from 'thkee-common';
import { CartStateV2 } from './cart-state.model';

export const CartActionsV2 = {
  cleanUserCart: createAction('[Cart V2] Clean User Cart'),
  cleanUserCartSuccess: createAction('[Cart V2] Clean User Success Cart'),

  initUserCart: createAction('[Cart V2] Init User Cart'),
  initUserCartSuccess: createAction('[Cart V2] Init User Success Cart', props<{ cartItems: CartStateV2 }>()),

  loadCart: createAction('[Cart V2] Load Cart'),
  loadCartSuccess: createAction('[Cart V2] Load Cart Success', props<{ cartItems: CartStateV2 }>()),
  loadCartFail: createAction('[Cart V2] Load Cart Fail', props<{ error: unknown }>()),

  addToCart: createAction('[Cart V2] Add to cart', props<any>()),
  addToCartSuccess: createAction('[Cart V2] Add to cart Success', props<any>()),

  removeToCart: createAction('[Cart V2] Remove to cart', props<{ id: string }>()),
  removeToCartSuccess: createAction('[Cart V2] Remove to cart Success', props<any>()),

  checkout: createAction('[Cart V2] Checkout'),
  checkoutSuccess: createAction('[Cart V2] Checkout Success', props<any>()),
  checkoutFailed: createAction('[Cart V2] Checkout Fail', props<{ error: unknown }>()),

  updateCartFavorite: createAction('[Cart V2] Update Cart Favorite', props<{ item: CartItemsDataV2 }>()),
  updateCartSummary: createAction('[Cart V2] Update Cart Summary', props<{ summary: CartSummaryV2 }>()),
};
